__turbopack_context__.v({
  "freeBox___4JvZp": "PlasmicFooterSection-module__cL3FFW__freeBox___4JvZp",
  "freeBox__civcz": "PlasmicFooterSection-module__cL3FFW__freeBox__civcz",
  "freeBox__pQle7": "PlasmicFooterSection-module__cL3FFW__freeBox__pQle7",
  "freeBox__tDnyA": "PlasmicFooterSection-module__cL3FFW__freeBox__tDnyA",
  "link__ilsmY": "PlasmicFooterSection-module__cL3FFW__link__ilsmY",
  "link__lwWca": "PlasmicFooterSection-module__cL3FFW__link__lwWca",
  "link__nywP2": "PlasmicFooterSection-module__cL3FFW__link__nywP2",
  "root": "PlasmicFooterSection-module__cL3FFW__root",
  "text__c1Roo": "PlasmicFooterSection-module__cL3FFW__text__c1Roo",
  "text__wGmQl": "PlasmicFooterSection-module__cL3FFW__text__wGmQl",
});
